﻿var ChartsPlugin = require('utils/charts/charts_plugin');
var ChartsMove = ChartsPlugin.extend({
    ui: {
        backward: '.js-chart-time-backward',
        forward: '.js-chart-time-forward',
        last: '.js-chart-time-to-end',
    },
    initPlugin: function (options) {
        var self = this;

        if (this.cache) {
            this.cache.on('charts:save:done', function () {
                self.onCacheSaveDone();
            });
        }

        $(this.ui.backward).on('click', function () {
            self.onMove(false);
        });

        $(this.ui.forward).on('click', function () {
            self.onMove(true);
        });

        $(this.ui.last).on('click', function () {
            self.view.setPeriod(undefined);
        });

        this.view.on('charts:period:set', function () {
            self.updateGui();
        });

        this.updateGui();
    },

    updateGui: function () {
        var self = this;
        var period = this.view.selectedPeriod;

        // tooltips
        var setTooltip = function (btn, from, till) {
            var hintTemplate = require('utils/templates/tooltip_range');

            var sTimeRange = hintTemplate({
                from: moment(from).format(self.view.rangeFormat),
                till: moment(till).format(self.view.rangeFormat),
            });

            var tip = $(btn).tooltip({
                animated: 'bottom',
                placement: 'top',
                container: 'body',
                trigger: 'hover',
                title: sTimeRange,
                html: true,
            });

            $(btn).attr('data-original-title', sTimeRange);
            var db = $(btn).attr('aria-describedby');
            var toolTipId = '#' + db;
            if (db && $(toolTipId).length > 0) {
                $(toolTipId + ' > div.tooltip-inner').html(sTimeRange);
            }
        };

        setTooltip(this.ui.backward, period.prevFrom(), period.prevTill());
        setTooltip(this.ui.forward, period.nextFrom(), period.nextTill());

        // buttons
        $(this.ui.last).attr('disabled', period.free || this.data.selectedSeries.length == 0 ? 'true' : null);
    },

    onCacheSaveDone: function () {
        // check if there is data in the cache
        periodPrev = this.getNextPeriod(false);
    },

    getNextPeriod: function (isForward) {
        var from = undefined;
        var till = undefined;
        var newPeriod = undefined;

        if (this.view && this.view.selectedPeriod) {
            if (isForward) {
                from = this.view.selectedPeriod.nextFrom();
                till = this.view.selectedPeriod.nextTill();
            } else {
                from = this.view.selectedPeriod.prevFrom();
                till = this.view.selectedPeriod.prevTill();
            }

            var newPeriod = $.extend(true, {}, this.view.selectedPeriod);
            newPeriod.from = from;
            newPeriod.till = till;
            newPeriod.free = this.view.selectedPeriod.free;
            newPeriod.name = undefined;
            newPeriod.moved = true;
            newPeriod.reload = undefined;
            newPeriod.originalName = this.view.selectedPeriod.originalName || this.view.selectedPeriod.name;
        }

        return newPeriod;
    },

    onMove: function (isForward) {
        if (!this.view || !this.view.selectedPeriod) return;
        this.view.setPeriod(this.getNextPeriod(isForward));
    },
});

module.exports = ChartsMove;
